import { memo } from 'react';
import { css, type Theme } from '@emotion/react';
import { borderRadius } from 'client/Theme';

export interface AvatarProps {
  alt: string;
  src: string | undefined;
  size?: number;
  shape?: 'square' | 'circle' | 'hexagon';
}

export const Avatar = memo<AvatarProps>(
  ({ size = 24, shape = 'square', ...other }) => {
    return (
      <img
        {...other}
        style={{ width: size, height: size }}
        css={[imgStyle, shape === 'circle' && circleStyle, shape === 'hexagon' && hexagonStyle]}
      />
    );
  },
  (prev, next) => {
    if (prev.src !== next.src) return false;
    return true;
  }
);

const placeholderImg = (theme: Theme) =>
  `url('data:image/svg+xml,<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">` +
  `<rect width="10" height="10" fill="${theme.color.grey[60].replace('#', '%23')}" /></svg>')`;

const hegaxonSVG =
  `url("data:image/svg+xml,%3Csvg width='125' height='110' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath ` +
  `d='M122.5 49a12 12 0 0 1 0 12l-24.8 43a12 12 0 0 1-10.4 6H37.7a12 12 0 0 1-10.4-6L2.5 61a12 12 0 0 1 0-12L27.3 6a12 ` +
  `12 0 0 1 10.4-6h49.6a12 12 0 0 1 10.4 6l24.8 43Z' fill='%23fff'/%3E%3C/svg%3E")`;

const imgStyle = (theme: Theme) => css`
  display: block;
  border-radius: ${borderRadius}px;
  object-fit: contain;

  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    font-size: 0;
    background-image: ${placeholderImg(theme)};
  }
`;

const circleStyle = css`
  border-radius: 50%;
`;

const hexagonStyle = css`
  mask-image: ${hegaxonSVG};
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  transform: scale(1.075);
`;
